/* eslint-disable */
import reducerConstant from 'common/reducerConstants';

const initialState = {
  token: null,
};

const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.tokenSave:
      return {
        ...state,
        token: action.payload.token,
      };
    case reducerConstant.resetTokenData:
      return {
        ...state,
        token: null,
      };

    case 'persist/REHYDRATE':
      return action.payload ? action.payload.tokenReducer : state;

    default:
      return state;
  }
};
export default tokenReducer;
